/**
 * Format a number according to the user's locale
 * @param value - The number to format
 * @returns Formatted string with appropriate separators
 */
export const formatNumber = (value: number): string => {
  return new Intl.NumberFormat(navigator.language || "en-US").format(value);
};
